import Papa from "papaparse";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportTicketsCsv = (rows, fileName) => {
    const csv = Papa.unparse(rows,{delimiter:";"});

    const blob = new Blob([csv], {
        type: "text/csv;charset=utf-8;",
    });

    saveAs(blob, `${fileName}.csv`);
};

export const exportTicketsPdf = ({
    rows,
    fileName,
    title,
    description,
    departureTime,
}) => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text(title, 14, 18);

    doc.setFontSize(11);

    let y = 30;

    if (description) {
        doc.text(description, 14, y);
        y += 7;
    }

    if (departureTime) {
        doc.text(`Departure: ${departureTime}`, 14, y);
        y += 10;
    }

    const headers = Object.keys(rows[0]);

    const body = rows.map(r => Object.values(r));

    autoTable(doc, {
        startY: y,
        head: [headers],
        body,
        styles: {
            fontSize: 8,
            cellPadding: 2,
        },
        headStyles: {
            fillColor: [25, 135, 84],
            textColor: 255,
        },
    });

    doc.save(`${fileName}.pdf`);
};